import {
  MetaDataActionTypes,
  MetaDataState,
  LOAD_META_DATA_SUCCESS,
  META_DATA_FAILURE,
  META_DATA_REQUEST,
} from "./types";

export const initialMetaDataState: MetaDataState = {
  metaData: {
    version: "",
    confirmation_certificate_german: "",
    confirmation_certificate_english: "",
    customer: "",
    address_required: true,
    support_hotline_german: "",
    support_hotline_english: "",
    support_hotline_is_enabled: false,
    group_membership_info_text_german: "",
    group_membership_info_text_english: "",
    group_membership_is_enabled: false,
    registration_info_text_german: "",
    registration_info_text_english: "",
    welcome_text_german: "",
    welcome_text_english: "",
    login_username_english: "",
    login_username_german: "",
    login_text_english: "",
    login_text_german: "",
    prepayment_conditions_german: "",
    prepayment_conditions_english: "",
    sort_filter: false,
  },
  isLoading: false,
  metaDataLoaded: false,
  isError: false,
};

export function metaDataReducer(
  state = initialMetaDataState,
  action: MetaDataActionTypes
): MetaDataState {
  switch (action.type) {
    case META_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case LOAD_META_DATA_SUCCESS:
      return {
        ...state,
        metaData: action.data,
        isLoading: false,
        metaDataLoaded: true,
      };
    case META_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    default:
      return state;
  }
}

export default metaDataReducer;
